import Pageheader from 'components/Pageheader'
import ModalContext from 'contexts/ModalContext';
import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from "react-helmet";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { GetCouponById, PostRedeemCoupon } from 'services/Api/Module/Coupon';
import useProfileStore from 'services/store/ProfileModule';
import moment from 'moment';
import BottomAction2 from 'components/BottomAction2';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import { isDisabled } from '@testing-library/user-event/dist/utils';
import { GetCustomerProfile } from 'services/Api/Module/Customer';
import helper from 'services/helper';

const CouponDetail = () => {
  const [searchParams,setSearchParams] = useSearchParams();
  const [topProfile, setTopProfile] = useState();
  
  const couponId = searchParams.get('couponId');
  const brandId = searchParams.get('restaurantId');
  const branchId = searchParams.get('branchId');
  const limit = searchParams.get('limit')
  const navigate = useNavigate();
  const { mAlert } = useContext(ModalContext);
  const [coupon, setCoupon] = useState();
  const [redeemCoupon, setRedeemCoupon] = useState();
  const [expired, setExpired] = useState();
  const [isConditionOpened, setIsConditionOpened] = useState(true);
  const profile = useProfileStore();
  const [refreshing, setRefreshing] = useState(false)
  const { lang } = useTranslations(); // สำหรับเปลี่ยนภาษา
  const { t } = useTranslations();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const numWithCommas = helper.FN.toNumberWithCommas

  const fetchGetCoupon = async (payload) => {
    try {
      const response = await GetCouponById({ params: payload });
      const resData = response?.data;
      if (resData.resultCode === 20000) {
        setCoupon(resData.resultData);
      } else if (resData.resultCode === 40304){
        handleBack();
      } else {
        mAlert.info({
          title: "ไม่พบ coupon",
          subTitle: "ไม่พบ coupon",
          content: "",
          onClose: () => { },
        });
      }
      setRefreshing(false)
    } catch (err) {
      setRefreshing(false)
      console.log('err ', err);
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => { },
      });
    }
  };
  const fetchPostRedeemCoupon = async (payload) => {
    try {
      const response = await PostRedeemCoupon({ data: payload });
      const resData = response?.data;
      if (resData.resultCode === 20000) {
        setRedeemCoupon(resData.resultData);
        navigate(`/coupon-qr?id=${resData?.resultData?.id}&restaurantId=${brandId}&branchId=${branchId}`)

      } else if (resData.resultCode === 40900) {
        mAlert.info({
          title: `${t.couponDetail.popup.notEnough}<br/>${t.couponDetail.popup.notEnough1}`,
          subTitle: "",
          content: "",
          onClose: () => { },
        });
      } else if (resData.resultCode === 40902){
        mAlert.info({
          title: t.couponDetail.popup.alreadyUsed,
          subTitle: "",
          content: "",
          onClose: () => { window.location.reload(); },
        });
        setSearchParams({ ...tempParams, limit: 1 });
      }else if (resData.resultCode === 40903){
        mAlert.info({
          title: t.couponDetail.popup.birthday,
          subTitle: "",
          content: "",
          onClose: () => { },
        });
      }
      else {
        mAlert.info({
          title: "ไม่พบ coupon",
          subTitle: "ไม่พบ coupon",
          content: "",
          onClose: () => { },
        });
      }
    } catch (err) {
      console.log('err ', err);
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => { },
      });
    }
  };
  const fetchGetProfile = async (payload) => {
    try {
        const response = await GetCustomerProfile({ params: payload });
        const resData = response?.data;
        setTopProfile(resData?.resultData)
        setRefreshing(false)
        return resData?.resultData;
    } catch (err) {
        console.log('err ', err);
        setRefreshing(false)
        mAlert.info({
            title: "แจ้งเตือน",
            subTitle: "มีบางอย่างผิดพลาด",
            content: "",
            onClose: () => { },
        });
    }
};
  useEffect(() => {
    onLoad()
  }, [profile]);
  useEffect(() => {
    let payload = {
      customerId: topProfile?.id,
      // customerId: profile?.customerProfile.id,
      couponId: couponId,
      restaurantId: brandId,
      branchId: branchId
    }
    if (topProfile?.id) {
      fetchGetCoupon(payload);
    }
  },[topProfile])
  useEffect(() => {
    if (limit == 1) {
      setExpired(true);
    } else {
      setExpired(false);
    }
  }, [coupon]);
  const tempParams = {
    restaurantId: brandId,
    branchId: branchId,
    couponId: couponId,
    limit: limit
}

  const handleBack = () => {
    navigate(`/coupon-all?restaurantId=${brandId}&branchId=${branchId}`)
  }
  const handleRedeemCoupon = () => {
    setIsButtonDisabled(true);
    let payload = {
      customerId: topProfile.id ? topProfile.id : "",
      restaurantBranchId: branchId,
      couponId: couponId,
      restaurantId: brandId
    }
    fetchPostRedeemCoupon(payload);
  }
  const formatDate = (date,lang) => {
    if (lang === 'th') {
      // return date
      return moment(date).locale('th').format('D MMM YYYY'); // ตัวอย่าง: 1 ก.ค. 2024
    } else {
      return moment(date).locale('en').format('D MMM YYYY'); // ตัวอย่าง: 1 Jul 2024
    }
  };
  const toggleCondition = () => {
    setIsConditionOpened(!isConditionOpened);
  }
  const handleSave = () => {
    mAlert.info({
      title: `${t?.couponDetail.title}`,
      // branch: coupon?.hasBranch !== 0 ? `${lang === 'th' ? 'สาขา : ' : 'Branch : '}${coupon?.branchName}` : "",
      subTitle: `${t?.couponDetail.body1} ${coupon?.usedPoint} ${t?.couponDetail.body2}  <br/> ${t?.couponDetail.body3}<br/> ${t?.couponDetail.body4}`,
      type: "confrim",
      mode: "blue",
      content: "",
      onClose: () => {},
      onYes: () => { handleRedeemCoupon() },
      onNo: () => { console.log('SAY NO') },
      disButton : isButtonDisabled
    })
  }
  const handleRefresh = () => {
    setRefreshing(true)
    onLoad();
  }
  const onLoad = async () => {
    const payload = {
      lineUid: profile?.lineUid
    };
    fetchGetProfile(payload)
    }
  return (
    <>
      <PullToRefresh
        refreshing={refreshing}
        onRefresh={handleRefresh}
      >
        <Helmet>
          <title>IMPACT Family</title>
          <meta name="title" content="Impact Family" />
          <meta name="description" content="Impact Family" />
          <meta name="keyword" content="" />
          <meta property="og:title" content="Impact Family" />
          <meta property="og:description" content="Impact Family" />
          <meta property="og:image" content="" />
          <meta property="og:url" content="" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Impact Family" />
        </Helmet>
        <div id="pageCoupon-details">
          <Pageheader pagename={t.couponDetail.header} onClick={handleBack} />

          <main id="top">
            <div className="wrapContent">

              <section id="pDetailsCoupon">
                <div className="bCouponImg">  {/* คูปองหมด className soldout */}
                  <div className="bPic">
                    <img src={coupon?.logo} alt="" />
                    {/* <div className="bLogo">
                      <img src={coupon?.imgCoupon} alt="" />
                    </div> */}
                    {expired ? <div className="bSoldout">{t.coupon.soldout}</div> : ""}
                  </div>
                </div>
                <div className="bDetailsCoupon">
                  <div className="bDetails">
                    <h2>{coupon?.restaurantName}</h2>
                    {/* {coupon?.hasBranch !== 0 ?
                    <h3>{coupon?.branchName}</h3>:""} */}
                    <p>{coupon?.couponName} </p>
                  </div>
                  <div className="bDate">
                    <p>
                      {formatDate(coupon?.startDate,lang)} - {formatDate(coupon?.endDate,lang)}
                    </p>
                  </div>
                  <div className="bPoint">
                    <p><span>{coupon?.usedPoint}</span> {t.coupon.points}</p>
                    <span>{t.couponDetail.pointCollection} <b>{coupon?.pointOnHand ? numWithCommas(Number(`${coupon.pointOnHand}`)) : 0}</b> {t.coupon.points}</span>
                  </div>
                </div>
              </section>
              <section id="pCondition">
                <div className="bCondition">
                  <div className="bAccord">
                    <div className={`btnAccord ${isConditionOpened ? 'opened' : ''}`} onClick={toggleCondition}>{t.couponDetail.conditions}</div>
                    {isConditionOpened && (
                      <div className="contentAccord">
                        <div className="bContent danger" dangerouslySetInnerHTML={{ __html: coupon?.conditions}} />
                      </div>
                    )}
                  </div>
                </div>
              </section>

              <BottomAction2 classBtn1='hide' isFormComplete={!expired} handleOk={handleSave} disbutton={isButtonDisabled}/>

              {/* Modal */}

            </div>
          </main>

        </div>
      </PullToRefresh>
    </>
  )
}

export default CouponDetail